/**
 * Holiday greeting presets. Each has id, label, optional image path, and confetti colors.
 * Add images in public/holidays/ (e.g. ramadan.png) to override the default emoji/icon.
 */
export const HOLIDAY_PRESETS = [
  {
    id: "ramadan",
    label: "Ramadan Kareem",
    image: "/holidays/ramadan.png",
    fallbackEmoji: "🌙",
    confettiColors: ["#0ea5e9", "#38bdf8", "#7dd3fc", "#fbbf24", "#fde047", "#22c55e"],
  },
  {
    id: "eid_fitr",
    label: "Eid Fitr Mubarak",
    image: "/holidays/eid-fitr.png",
    fallbackEmoji: "🕌",
    confettiColors: ["#22c55e", "#4ade80", "#fbbf24", "#fde047", "#0ea5e9", "#f472b6"],
  },
  {
    id: "eid_adha",
    label: "Eid Adha Mubarak",
    image: "/holidays/eid-adha.png",
    fallbackEmoji: "🌙",
    confettiColors: ["#22c55e", "#15803d", "#fbbf24", "#fde047", "#0ea5e9", "#f472b6"],
  },
  {
    id: "christmas",
    label: "Merry Christmas",
    image: "/holidays/christmas.png",
    fallbackEmoji: "🎄",
    confettiColors: ["#dc2626", "#22c55e", "#15803d", "#fbbf24", "#fde047", "#ffffff"],
  },
  {
    id: "new_year",
    label: "Happy New Year",
    image: "/holidays/new-year.png",
    fallbackEmoji: "🎆",
    confettiColors: ["#fbbf24", "#fde047", "#ffffff", "#c084fc", "#a78bfa", "#38bdf8"],
  },
];

export const FIREBASE_HOLIDAY_PATH = "settings/holidayGreeting";
